import { Expose } from 'class-transformer'

export class Flag {
  static type = 'flag'

  type = Flag.type

  @Expose({ name: 'xid' })
  guid?: string

  name?: string
}
